// Dựng cây lệnh commander đầy đủ — KHÔNG parse argv.
//
// VÌ SAO TÁCH KHỎI `index.ts`: `index.ts` gọi `parseAsync` ngay lúc import, nên
// test không thể import nó để duyệt registry. AC2 của T0 đòi kiểm "MỌI lệnh lá
// đều có `--non-interactive`" trên toàn bộ 31 lệnh, không lấy mẫu — muốn kiểm
// được thì phải có một hàm dựng cây rồi trả về, tách khỏi vế chạy.

import { Command } from "commander";
import { registerAddCommand } from "../commands/add-repo.js";
import { registerAiCommand } from "../commands/ai.js";
import { registerCommConnectCommand } from "../commands/comm-connect.js";
import { registerDebateCommand } from "../commands/debate.js";
import { registerDoctorCommand } from "../commands/doctor.js";
import { registerGitnexusCommand } from "../commands/gitnexus.js";
import { registerInitCommand } from "../commands/init.js";
import { registerLoginCommand } from "../commands/login.js";
import { registerLogoutCommand } from "../commands/logout.js";
import { registerMcpRunCommand } from "../commands/mcp-run.js";
import { registerNotifyCommand } from "../commands/notify.js";
import { registerPackCommand } from "../commands/pack-status-and-version-check.js";
import { registerPrintIdTokenCommand } from "../commands/print-id-token.js";
import { registerRestoreCommand } from "../commands/restore.js";
import { registerReviewCommand } from "../commands/review.js";
import { registerScanCommand } from "../commands/scan.js";
import { registerStatusCommand } from "../commands/status.js";
import { registerSyncCommand } from "../commands/sync.js";
import { registerToolsCommand } from "../commands/tools.js";
import { registerUninstallCommand } from "../commands/uninstall.js";
import { registerUpdateCommand } from "../commands/update.js";
import { renderAvatarBanner } from "./avatar-ascii-banner.js";
import {
  attachNonInteractiveFlagToAllCommands,
  registerNonInteractiveHook,
} from "./non-interactive-context.js";
import { readCliVersion } from "./read-cli-version-from-package-json.js";

/**
 * Trả cây lệnh đã đăng ký đủ, đã gắn `--non-interactive` ở mọi cấp và đã cài
 * hook bơm trạng thái. Caller tự gọi `parseAsync`.
 */
export function buildAvatarCommandRegistry(): Command {
  const cliVersion = readCliVersion();
  const program = new Command();

  program
    .name("avatar")
    .description("AI harness CLI for NAL Vietnam engineering")
    .version(cliVersion, "-v, --version", "Hiển thị phiên bản Avatar CLI")
    // Override mặc định của commander để in banner kèm version. Commander cho phép
    // custom output qua configureOutput nhưng cách đơn giản nhất là intercept ở argv.
    .addHelpText(
      "beforeAll",
      () =>
        `\n${renderAvatarBanner({ tagline: `v${cliVersion} · AI harness CLI for NAL Vietnam` })}\n\n`,
    );

  registerLoginCommand(program);
  registerLogoutCommand(program);
  registerInitCommand(program);
  registerSyncCommand(program);
  registerScanCommand(program);
  registerReviewCommand(program);
  registerStatusCommand(program);
  registerDoctorCommand(program);
  registerRestoreCommand(program);
  registerToolsCommand(program);
  registerDebateCommand(program);
  registerMcpRunCommand(program);
  registerAiCommand(program);
  registerCommConnectCommand(program);
  registerGitnexusCommand(program);
  registerPackCommand(program);
  registerAddCommand(program);
  registerUninstallCommand(program);
  registerUpdateCommand(program);
  registerPrintIdTokenCommand(program);
  registerNotifyCommand(program);

  // Gắn cờ SAU khi mọi lệnh đã đăng ký: duyệt cây một lượt phủ hết, kể cả lệnh
  // hidden (`mcp-run`, `print-id-token`) và lệnh thêm về sau.
  attachNonInteractiveFlagToAllCommands(program);
  registerNonInteractiveHook(program);

  return program;
}

/** Duyệt cây, trả mọi lệnh LÁ (lệnh không có lệnh con). Dùng cho test AC2. */
export function collectLeafCommands(root: Command): Command[] {
  if (root.commands.length === 0) return [root];
  return root.commands.flatMap((child) => collectLeafCommands(child));
}
